import * as React from "react";
import styles from "./Input.module.css";
import { InputProps } from "@/types/ui.types";

interface EnhancedInputProps extends InputProps {
  error?: boolean;
  variant?: "default" | "dark";
}

export const Input = React.forwardRef<HTMLInputElement, EnhancedInputProps>(
  ({ className = "", type = "text", icon, onIconClick, error, variant = "default", ...props }, ref) => {
    
    
    const inputClasses = [
      styles.inputBase,
      type === "search" ? styles.inputSearch : styles.inputText,
      variant === "dark" && styles.inputDark,
      icon && styles.inputWithIconRight,
      error && styles.inputError,
      className
    ].filter(Boolean).join(" ");

    return (
      <div className={styles.inputWrapper}>
        {type === "search" && (
          <div className={styles.inputSearchIcon}>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z"
                stroke={variant === "dark" ? "var(--dm-grey-txt-4)" : "#9CA3AF"}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M15 15L11 11"
                stroke={variant === "dark" ? "var(--dm-grey-txt-4)" : "#9CA3AF"}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        )}
        
        <input
          type={type}
          ref={ref}
          className={inputClasses}
          {...props}
        />

        {icon && (
          <button 
            type="button" 
            onClick={onIconClick} 
            className={styles.inputRightIcon}
            tabIndex={-1}
          >
            {icon}
          </button>
        )}
      </div>
    );
  }
);

Input.displayName = "Input";